<template>
  <!-- 头部整体盒子 -->
  <div
    id="header"
    class="container-fuild"
    :class="{ 'header-scrolled': isScrolled }"
  >
    <!-- 头部顶部 -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img
          @dragstart.prevent
          src="https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240426/image 246.png"
        />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>

      <div class="header-nav-phone">
        <span
          class="glyphicon glyphicon-earphone"
          style="font-size: 13px"
        ></span
        ><span>&nbsp;021-60410579</span>
        <!-- <span class="glyphicon glyphicon-envelope"></span>{{ config.email }} -->
        <!-- <img src="@/assets/img/logo_black.png" /> -->
      </div>

      <div v-if="showMemberAuth" class="header-nav-auth">
        <el-button size="mini" type="success" @click="goLogin"
          >会员登录</el-button
        >
        <el-button size="mini" type="info" @click="goRegister"
          >会员注册</el-button
        >
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img
          @dragstart.prevent
          class="center-block"
          src="https://points-mall00.oss-cn-beijing.aliyuncs.com/integral/images/20240426/1 1114.png"
          alt="logo"
        />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "Header",
  data() {
    return {
      config: config,
      isScrolled: false,
      showMemberAuth: false,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "产品介绍",
          path: "/software",
          children: [
            /*         {
              id: "001",
              path: "/software/newMedia",
              name: "新媒体",
            },
            {
              id: "002",
              path: "/software/rightShoping",
              name: "权益商城",
            }, */
            {
              id: "003",
              path: "/software/reductionActive",
              name: "立减金活动",
            },
            /*   {
              id: "004",
              path: "/software/supplyChain",
              name: "电商金融",
            }, */
          ],
        },

        {
          name: "案例",
          path: "/service",
          children: [
            // {
            //   id: "001",
            //   path: "/service",
            //   name: "培训推广",
            // },
            // {
            //   id: "002",
            //   path: "/service",
            //   name: "权益对接",
            // },
            // {
            //   id: "003",
            //   path: "/service",
            //   name: "支付案例",
            // },
          ],
        },
        {
          name: "推广策划",
          path: "/newsinformation",
          children: [],
        },
        // {
        //   name: "相关服务",
        //   path: "/service",
        //   children: [],
        // },
        {
          name: "新闻资讯",
          path: "/informationCenter",
          children: [],
        },
        {
          name: "关于我们",
          path: "/aboutUs",
          children: [],
        },
        // {
        //   name: "公司介绍",
        //   path: "/companyintroduction",
        //   children: [],
        // },
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: [],
        // },
        {
          name: "联系我们",
          path: "/contactus",
          children: [],
        },
        /* {
          name: "车主服务",
          path: "/carService",
          children: [],
        }, */
      ],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.syncNavIndex(to.path);
      },
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    syncNavIndex(path) {
      const index = this.navList.findIndex((item) => {
        if (item.path === "/" && (path === "/" || path === "/home")) {
          return true;
        }
        if (item.path !== "/" && path.startsWith(item.path)) {
          return true;
        }
        if (item.children && item.children.length) {
          return item.children.some((child) => path.startsWith(child.path));
        }
        return false;
      });
      if (index !== -1) {
        this.navIndex = index;
        this.menuName = this.navList[index].name;
        sessionStorage.setItem("navIndex", index);
      }
    },
    goLogin() {
      // window.onbeforeunload = null;
      window.location.href = "https://y-yao.cc/login.html";
    },

    goRegister() {
      window.location.href = "https://y-yao.cc/reg.html";
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.header-nav-phone {
  color: #525252;
}
/* 顶部 */

@media screen and (min-width: 997px) {
  #header {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    transition: background var(--transition-base, 0.35s ease),
      box-shadow var(--transition-base, 0.35s ease),
      padding var(--transition-base, 0.35s ease);
    top: 0;
    z-index: 999;
    width: 100%;
    position: sticky;
  }
  #header.header-scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  }
  #header .header-nav-m .header-nav-m-logo img {
    height: 100% !important;
  }
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 60px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: var(--text-primary, #1a1d26);
  font-family: var(--font-family, "Noto Sans SC", sans-serif);
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.02em;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  height: 0;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  width: 130px;
  top: 100%;
  left: 0;
  z-index: 999999;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(8px);
  transition: height 0.35s ease, opacity 0.3s ease, transform 0.3s ease,
    visibility 0.3s ease;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #eee;
  transition: background 0.2s ease, color 0.2s ease;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:last-child {
  border-bottom: none;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  height: auto;
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: rgba(19, 88, 254, 0.06);
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  color: #333;
  transition: color 0.2s ease;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover > a {
  color: #1358fe;
}
@media screen and (max-width: 997px) {
  #header {
    background: #f4f4f4;
    transition: all ease 0.6s;
    /* background: #f4f4f4; */
    /* transition: all ease 0.6s; */
    /* background-color: transparent; */
    /* position: absolute; */
    /* top: 0; */
    /* z-index: 999; */
    /* width: 100%; */
  }
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 64px;
    position: relative;
  }
  #header .header-nav-m .header-nav-m-logo img {
    width: 80px;
    // height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue